import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/sidebar';
import Header from '../components/Header';
import UserComponent from '../components/users/UserComponent';

const UsersScreen = ({ user }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || (user && !user.isAdmin)) {
      navigate('/login');
    }
  });

  return (
    <>
      <Sidebar />
      <main className='main-wrap'>
        <Header />
        <UserComponent user={user} />
      </main>
    </>
  );
};

export default UsersScreen;
